import { render } from "./UserPermissionRuleEditor.vue?vue&type=template&id=5add2372&scoped=true"
import script from "./UserPermissionRuleEditor.vue?vue&type=script&lang=js"
export * from "./UserPermissionRuleEditor.vue?vue&type=script&lang=js"

import "./UserPermissionRuleEditor.vue?vue&type=style&index=0&id=5add2372&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5add2372"]])

export default __exports__